import { createSlice } from '@reduxjs/toolkit';
import { updateCart } from '../utils/cartUtils';

const initialState = localStorage.getItem('cart')
  ? JSON.parse(localStorage.getItem('cart'))
  : { cartItems: [] };

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
    const { user, ...item } = action.payload;
    if (!item.isbn) {
        console.error('Item must have an isbn');
        return state;
    }
    const existItem = state.cartItems.find((x) => x.isbn === item.isbn);
    if (existItem) {
        console.warn('Item already exists in cart');
        return state;
    }
    state.cartItems.push({
      ...item,
      lastRefreshedAt: item.lastRefreshedAt || Date.now(),
      updatedAt: item.updatedAt || Date.now(),
    });
    return updateCart(state);
    },

    updateCartItem: (state, action) => {
      const { isbn, ...updates } = action.payload;
      const item = state.cartItems.find((x) => x.isbn === isbn);
      if (item) {
        Object.assign(item, updates, {
          updatedAt: updates.updatedAt || Date.now(),
          lastRefreshedAt: updates.lastRefreshedAt || item.lastRefreshedAt || Date.now(),
        });
      }
      return updateCart(state);
    },

    removeFromCart: (state, action) => {
    // _id has to be changed with isbn or barcode or ean
      state.cartItems = state.cartItems.filter((x) => x.isbn !== action.payload);
      return updateCart(state);
    },
    
    clearCartItems: (state, action) => {
      state.cartItems = [];
      localStorage.setItem('cart', JSON.stringify(state));
    },
    // NOTE: here we need to reset state for when a user logs out so the next
    // user doesn't inherit the previous users cart and shipping
    resetCart: (state) => (state = initialState),
  },
});

export const {
  addToCart,
  updateCartItem,
  removeFromCart,
  clearCartItems,
  resetCart,
} = cartSlice.actions;

export default cartSlice.reducer;